<!-- Header -->
<div class="flex justify-between items-center mb-6">
  <div>
    <h2 class="text-2xl font-semibold text-gray-800">Mechanics Management</h2>
    <p class="text-sm text-gray-500 mt-1">Manage and verify all registered mechanics.</p>
  </div>
  <button
    (click)="loadMechanics()"
    class="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M4 4v5h.582M20 20v-5h-.581M5.635 19A9 9 0 104.582 9H4" />
    </svg>
    Refresh
  </button>
</div>

<!-- Loading Spinner -->
<div *ngIf="isLoading" class="flex justify-center items-center py-20">
  <div class="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
</div>

<!-- Error State -->
<div *ngIf="!isLoading && errorMessage"
  class="flex items-center gap-3 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
  <svg class="w-5 h-5 shrink-0" fill="currentColor" viewBox="0 0 20 20">
    <path fill-rule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-9.25a.75.75 0 011.5 0v3.5a.75.75 0 01-1.5 0v-3.5zm.75 6a.75.75 0 100-1.5.75.75 0 000 1.5z"
      clip-rule="evenodd" />
  </svg>
  <span>{{ errorMessage }}</span>
  <button (click)="loadMechanics()" class="ml-auto text-sm underline">Retry</button>
</div>

<!-- Data Table -->
<app-data-table
  *ngIf="!isLoading && !errorMessage"
  title="Mechanics"
  [data]="mechanics"
  [columns]="columns">
</app-data-table>

<!-- Action Template -->
<ng-template #actionTemplate let-item>
  <div class="flex items-center gap-3">

    <!-- View -->
    <button
      (click)="viewMechanic(item)"
      class="text-gray-500 hover:text-blue-600 transition"
      title="View Profile">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
    </button>

    <!-- Verify / Un-verify -->
    <button
      (click)="verifyMechanic(item)"
      class="text-gray-500 hover:text-green-600 transition"
      [title]="item.verificationStatus === 'Approved' ? 'Un-verify' : 'Verify'">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
      </svg>
    </button>

    <!-- Block / Unblock -->
    <button
      (click)="toggleBlock(item)"
      class="text-gray-500 transition"
      [class.hover:text-red-600]="item.accountStatus === 'Active'"
      [class.hover:text-emerald-600]="item.accountStatus !== 'Active'"
      [title]="item.accountStatus === 'Active' ? 'Suspend' : 'Activate'">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" />
        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
      </svg>
    </button>

  </div>
</ng-template>